import { Box, TextField, MenuItem } from '@mui/material';

interface Account {
  id: number;
  firstName?: string;
  lastName?: string;
}

/**
 * Filter the rule list by VK account. Hidden when the user has fewer than
 * two accounts (nothing to filter). Shared by all three tool pages.
 */
export default function AccountFilterBar({
  accounts,
  value,
  onChange,
}: {
  accounts: Account[];
  value: string;
  onChange: (v: string) => void;
}) {
  if (accounts.length < 2) return null;
  return (
    <Box sx={{ mb: 2, maxWidth: 320 }}>
      <TextField
        select
        fullWidth
        size="small"
        label="VK-аккаунт"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value="">Все аккаунты</MenuItem>
        {accounts.map((a) => (
          <MenuItem key={a.id} value={String(a.id)}>
            {a.firstName} {a.lastName}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
}
